var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{on:{"submit":_vm.submit}},[_vm._t("header"),_vm._v(" "),_vm._l((_vm.serverMetaErrors),function(error,i){return _c('div',{key:i,staticClass:"notification is-danger has-text-centered"},[_vm._v("\n    "+_vm._s(_vm.$gettext(error.description, 'API message'))+"\n  ")])}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }